export interface Comic {
  id: string;
  title: string;
  genre: string;
  status: string;
  score: string;
  chapter: string;
  updateTime: string;
  tags: string[];
  image: string;
  desc: string;
  isNew?: boolean;
  rank?: number;
}

export const todayUpdates: Comic[] = [
  {
    id: 't1',
    title: '星海骑士团',
    genre: '冒险',
    status: '连载中',
    score: '9.2',
    chapter: '第132话',
    updateTime: '今天 08:30',
    tags: ['星际', '热血', '群像'],
    desc: '少年骑士在星海之间集结伙伴，为守护最后的家园踏上远征。',
    image: 'https://readdy.ai/api/search-image?query=a%20young%20knight%20in%20luminous%20galaxy%20armor%20holding%20a%20glowing%20sword%20among%20floating%20planets%20and%20stars%2C%20vibrant%20anime%20comic%20cover%20art%2C%20bold%20clean%20line%20art%2C%20cel%20shading%2C%20dynamic%20composition%2C%20colorful%20background%2C%20high%20detail&width=600&height=800&seq=comic-t1&orientation=portrait',
  },
  {
    id: 't2',
    title: '孤岛料理日记',
    genre: '治愈',
    status: '连载中',
    score: '8.8',
    chapter: '第76话',
    updateTime: '今天 09:10',
    tags: ['美食', '日常', '治愈'],
    desc: '岛上主厨每日用最新鲜的食材，为旅人端上暖心的一餐。',
    image: 'https://readdy.ai/api/search-image?query=a%20cheerful%20chef%20cooking%20on%20a%20small%20tropical%20island%20kitchen%20with%20fresh%20ingredients%20and%20steaming%20dishes%2C%20warm%20cozy%20anime%20comic%20cover%20art%2C%20soft%20cel%20shading%2C%20bright%20palette%2C%20high%20detail&width=600&height=800&seq=comic-t2&orientation=portrait',
  },
  {
    id: 't3',
    title: '时空旅社',
    genre: '奇幻',
    status: '连载中',
    score: '9.0',
    chapter: '第58话',
    updateTime: '今天 10:00',
    tags: ['穿越', '悬疑', '奇幻'],
    desc: '一家只在午夜营业的旅社，每个房间都通向不同的时代。',
    image: 'https://readdy.ai/api/search-image?query=a%20vintage%20inn%20with%20a%20glowing%20grandfather%20clock%20portal%20and%20mysterious%20traveler%20at%20midnight%2C%20moody%20anime%20comic%20cover%20art%2C%20teal%20and%20amber%20lighting%2C%20cel%20shading%2C%20high%20detail&width=600&height=800&seq=comic-t3&orientation=portrait',
  },
  {
    id: 't4',
    title: '剑与契约',
    genre: '热血',
    status: '连载中',
    score: '9.4',
    chapter: '第201话',
    updateTime: '今天 11:20',
    tags: ['战斗', '契约', '王道'],
    desc: '无名剑客与古老精灵签订契约，从凡尘剑客走向大陆传说。',
    image: 'https://readdy.ai/api/search-image?query=a%20fantasy%20swordsman%20signing%20a%20glowing%20magic%20contract%20with%20an%20ethereal%20spirit%2C%20epic%20anime%20comic%20cover%20art%2C%20vibrant%20cel%20shading%2C%20dramatic%20lighting%2C%20high%20detail&width=600&height=800&seq=comic-t4&orientation=portrait',
  },
  {
    id: 't5',
    title: '午夜图书馆',
    genre: '悬疑',
    status: '连载中',
    score: '8.7',
    chapter: '第44话',
    updateTime: '今天 12:40',
    tags: ['悬疑', '都市', '奇幻'],
    desc: '闭馆后的图书馆里，每一本书都在等待它真正的读者。',
    image: 'https://readdy.ai/api/search-image?query=a%20girl%20reading%20among%20towering%20midnight%20library%20shelves%20with%20glowing%20books%20and%20soft%20starlight%2C%20mystical%20anime%20comic%20cover%20art%2C%20cool%20toned%20cel%20shading%2C%20high%20detail&width=600&height=800&seq=comic-t5&orientation=portrait',
  },
  {
    id: 't6',
    title: '云端邮差',
    genre: '治愈',
    status: '连载中',
    score: '8.9',
    chapter: '第63话',
    updateTime: '今天 13:15',
    tags: ['天空', '日常', '治愈'],
    desc: '穿梭在云上城市的邮差少年，把每一封没说出口的心意送达。',
    image: 'https://readdy.ai/api/search-image?query=a%20courier%20boy%20flying%20over%20a%20sky%20city%20among%20soft%20clouds%20delivering%20letters%2C%20dreamy%20anime%20comic%20cover%20art%2C%20bright%20cel%20shading%2C%20blue%20and%20white%20sky%2C%20high%20detail&width=600&height=800&seq=comic-t6&orientation=portrait',
  },
];

export const hotRanking: Comic[] = [
  {
    id: 'r1',
    title: '破晓之刃',
    genre: '热血',
    status: '连载中',
    score: '9.6',
    chapter: '第248话',
    updateTime: '今天',
    tags: ['战斗', '王道'],
    desc: '黎明战场上的无名刀客，以一把破晓之刃改写王朝命运。',
    rank: 1,
    image: 'https://readdy.ai/api/search-image?query=a%20fierce%20warrior%20drawing%20a%20dawn%20blade%20against%20a%20golden%20sunrise%20battlefield%2C%20epic%20anime%20comic%20cover%20art%2C%20warm%20coral%20tones%2C%20dynamic%20action%2C%20high%20detail&width=600&height=800&seq=comic-r1&orientation=portrait',
  },
  {
    id: 'r2',
    title: '校园侦探社',
    genre: '推理',
    status: '连载中',
    score: '9.1',
    chapter: '第87话',
    updateTime: '今天',
    tags: ['校园', '推理'],
    desc: '两位高中生侦探，用逻辑破解校园里接踵而来的离奇谜题。',
    rank: 2,
    image: 'https://readdy.ai/api/search-image?query=teenage%20detective%20duo%20at%20a%20school%20with%20magnifying%20glass%20and%20mystery%20vibes%2C%20playful%20anime%20comic%20cover%20art%2C%20school%20background%2C%20cel%20shading%2C%20high%20detail&width=600&height=800&seq=comic-r2&orientation=portrait',
  },
  {
    id: 'r3',
    title: '龙眠之地',
    genre: '奇幻',
    status: '连载中',
    score: '9.3',
    chapter: '第109话',
    updateTime: '今天',
    tags: ['龙', '冒险'],
    desc: '沉睡巨龙守护的山谷，藏着被遗忘千年的秘密与传承。',
    rank: 3,
    image: 'https://readdy.ai/api/search-image?query=a%20sleeping%20dragon%20curled%20around%20an%20ancient%20mountain%20with%20ruins%20and%20mist%2C%20majestic%20anime%20comic%20cover%20art%2C%20teal%20and%20green%20tones%2C%20high%20detail&width=600&height=800&seq=comic-r3&orientation=portrait',
  },
  {
    id: 'r4',
    title: '机械之心',
    genre: '科幻',
    status: '连载中',
    score: '9.0',
    chapter: '第72话',
    updateTime: '今天',
    tags: ['机甲', '末世'],
    desc: '拥有人类之心的机器人，在末世都市寻找存在的意义。',
    rank: 4,
    image: 'https://readdy.ai/api/search-image?query=a%20humanoid%20robot%20with%20a%20glowing%20heart%20core%20in%20a%20futuristic%20sci-fi%20city%2C%20sleek%20anime%20comic%20cover%20art%2C%20cool%20neon%20tones%2C%20high%20detail&width=600&height=800&seq=comic-r4&orientation=portrait',
  },
  {
    id: 'r5',
    title: '山海异闻录',
    genre: '古风',
    status: '已完结',
    score: '9.5',
    chapter: '已完结',
    updateTime: '昨天',
    tags: ['神话', '国风'],
    desc: '以古卷为引，讲述山海间神兽与人族的恩怨情仇。',
    rank: 5,
    image: 'https://readdy.ai/api/search-image?query=mythical%20beasts%20from%20ancient%20mountains%20and%20seas%20in%20chinese%20mythology%2C%20elegant%20anime%20comic%20cover%20art%2C%20warm%20ink%20and%20gold%20tones%2C%20high%20detail&width=600&height=800&seq=comic-r5&orientation=portrait',
  },
  {
    id: 'r6',
    title: '告白气球',
    genre: '恋爱',
    status: '连载中',
    score: '8.6',
    chapter: '第51话',
    updateTime: '昨天',
    tags: ['校园', '纯爱'],
    desc: '鼓起勇气的那一天，一只气球把我的心意吹到你面前。',
    rank: 6,
    image: 'https://readdy.ai/api/search-image?query=a%20boy%20holding%20a%20bunch%20of%20balloons%20confessing%20to%20a%20girl%20under%20cherry%20blossoms%2C%20romantic%20anime%20comic%20cover%20art%2C%20soft%20pink%20tones%2C%20cel%20shading%2C%20high%20detail&width=600&height=800&seq=comic-r6&orientation=portrait',
  },
];

export const editorPicks: Comic[] = [
  {
    id: 'e1',
    title: '夜航星图',
    genre: '奇幻',
    status: '连载中',
    score: '9.4',
    chapter: '第118话',
    updateTime: '编辑力荐',
    tags: ['星海', '冒险'],
    desc: '飞艇在夜空航行，领航员以星辰为图，寻找失落大陆的坐标。',
    image: 'https://readdy.ai/api/search-image?query=a%20navigator%20charting%20constellations%20aboard%20a%20night%20airship%20over%20a%20starry%20sky%2C%20dreamy%20anime%20comic%20cover%20art%2C%20deep%20indigo%20and%20amber%20lighting%2C%20high%20detail&width=600&height=800&seq=comic-e1&orientation=portrait',
  },
  {
    id: 'e2',
    title: '茶馆物语',
    genre: '治愈',
    status: '连载中',
    score: '9.2',
    chapter: '第93话',
    updateTime: '编辑力荐',
    tags: ['日常', '茶道'],
    desc: '老茶馆里的一盏盏热茶，沏出了邻里间最朴素的温情。',
    image: 'https://readdy.ai/api/search-image?query=a%20cozy%20teahouse%20with%20steam%20rising%2C%20old%20teapots%20and%20warm%20paper%20lanterns%2C%20serene%20anime%20comic%20cover%20art%2C%20warm%20amber%20tones%2C%20high%20detail&width=600&height=800&seq=comic-e2&orientation=portrait',
  },
  {
    id: 'e3',
    title: '像素勇者',
    genre: '游戏',
    status: '连载中',
    score: '8.8',
    chapter: '第40话',
    updateTime: '编辑力荐',
    tags: ['像素', '冒险'],
    desc: '困在游戏世界里的勇者，用一次次攻略换回现实的光。',
    image: 'https://readdy.ai/api/search-image?query=an%208-bit%20style%20hero%20adventuring%20across%20a%20colorful%20pixel%20game%20world%2C%20retro%20anime%20comic%20cover%20art%2C%20bright%20blocky%20pixels%2C%20vibrant%2C%20high%20detail&width=600&height=800&seq=comic-e3&orientation=portrait',
  },
  {
    id: 'e4',
    title: '樱花失物招领处',
    genre: '日常',
    status: '连载中',
    score: '8.9',
    chapter: '第66话',
    updateTime: '编辑力荐',
    tags: ['治愈', '校园'],
    desc: '被遗忘的东西都会来到这里，等待一场温柔的归还。',
    image: 'https://readdy.ai/api/search-image?query=a%20lost%20and%20found%20desk%20surrounded%20by%20falling%20sakura%20petals%20with%20tiny%20keepsakes%2C%20gentle%20anime%20comic%20cover%20art%2C%20soft%20pink%20and%20cream%20tones%2C%20high%20detail&width=600&height=800&seq=comic-e4&orientation=portrait',
  },
];

export const newReleases: Comic[] = [
  {
    id: 'n1',
    title: '雪原孤狼',
    genre: '热血',
    status: '新作',
    score: '9.0',
    chapter: '第12话',
    updateTime: '今日首发',
    tags: ['荒野', '战斗'],
    desc: '冰原上独行的猎人，在风雪中遇见了改变命运的一匹孤狼。',
    isNew: true,
    image: 'https://readdy.ai/api/search-image?query=a%20lone%20wolf%20silhouette%20walking%20through%20snowy%20plains%20at%20dawn%20beside%20a%20hunter%2C%20dramatic%20anime%20comic%20cover%20art%2C%20cool%20white%20and%20blue%20tones%2C%20high%20detail&width=600&height=800&seq=comic-n1&orientation=portrait',
  },
  {
    id: 'n2',
    title: '都市浮世绘',
    genre: '现实',
    status: '新作',
    score: '8.7',
    chapter: '第18话',
    updateTime: '本周新作',
    tags: ['都市', '群像'],
    desc: '霓虹闪烁的夜里，每个人都在为各自的生活认真活着。',
    isNew: true,
    image: 'https://readdy.ai/api/search-image?query=a%20bustling%20modern%20city%20street%20at%20night%20with%20neon%20signs%20and%20crowds%2C%20lively%20anime%20comic%20cover%20art%2C%20warm%20and%20cool%20neon%20mix%2C%20high%20detail&width=600&height=800&seq=comic-n2&orientation=portrait',
  },
  {
    id: 'n3',
    title: '猫的报恩夜',
    genre: '奇幻',
    status: '新作',
    score: '8.5',
    chapter: '第9话',
    updateTime: '本周新作',
    tags: ['猫咪', '治愈'],
    desc: '月光下的屋顶上，一只神秘黑猫守护着整座城的好梦。',
    isNew: true,
    image: 'https://readdy.ai/api/search-image?query=a%20black%20cat%20sitting%20on%20a%20rooftop%20under%20a%20full%20moon%20with%20glowing%20eyes%20over%20a%20sleeping%20city%2C%20whimsical%20anime%20comic%20cover%20art%2C%20deep%20blue%20night%20tones%2C%20high%20detail&width=600&height=800&seq=comic-n3&orientation=portrait',
  },
  {
    id: 'n4',
    title: '天工造物',
    genre: '机巧',
    status: '新作',
    score: '8.8',
    chapter: '第14话',
    updateTime: '本周新作',
    tags: ['机关', '匠人'],
    desc: '巧匠用一双妙手与满室齿轮，唤醒沉睡千年的木质机关。',
    isNew: true,
    image: 'https://readdy.ai/api/search-image?query=an%20artisan%20crafting%20a%20giant%20magical%20wooden%20mechanism%20in%20a%20workshop%20full%20of%20gears%2C%20inventive%20anime%20comic%20cover%20art%2C%20warm%20wood%20tones%2C%20high%20detail&width=600&height=800&seq=comic-n4&orientation=portrait',
  },
];

export const highScores: Comic[] = [
  {
    id: 's1',
    title: '春日的告别信',
    genre: '治愈',
    status: '已完结',
    score: '9.7',
    chapter: '已完结',
    updateTime: '完结佳作',
    tags: ['青春', '纯爱'],
    desc: '毕业那年，一封迟到的信，写满了没说出口的春天。',
    image: 'https://readdy.ai/api/search-image?query=a%20girl%20writing%20a%20farewell%20letter%20under%20a%20blooming%20spring%20tree%20with%20falling%20petals%2C%20nostalgic%20anime%20comic%20cover%20art%2C%20soft%20warm%20tones%2C%20high%20detail&width=600&height=800&seq=comic-s1&orientation=portrait',
  },
  {
    id: 's2',
    title: '深海列车',
    genre: '科幻',
    status: '连载中',
    score: '9.5',
    chapter: '第134话',
    updateTime: '高分连载',
    tags: ['深海', '悬疑'],
    desc: '一列行驶在发光深海的列车，载着乘客驶向未知的终点站。',
    image: 'https://readdy.ai/api/search-image?query=a%20submarine%20train%20traveling%20through%20a%20luminous%20deep%20ocean%20with%20glowing%20marine%20life%2C%20immersive%20anime%20comic%20cover%20art%2C%20deep%20teal%20tones%2C%20high%20detail&width=600&height=800&seq=comic-s2&orientation=portrait',
  },
  {
    id: 's3',
    title: '萤火之森计划',
    genre: '奇幻',
    status: '连载中',
    score: '9.3',
    chapter: '第57话',
    updateTime: '高分连载',
    tags: ['森林', '冒险'],
    desc: '孩子们用一场萤火计划，点亮了被遗忘森林里的秘密。',
    image: 'https://readdy.ai/api/search-image?query=children%20releasing%20fireflies%20in%20a%20magical%20forest%20at%20dusk%20with%20glowing%20lights%2C%20enchanting%20anime%20comic%20cover%20art%2C%20teal%20and%20gold%20tones%2C%20high%20detail&width=600&height=800&seq=comic-s3&orientation=portrait',
  },
  {
    id: 's4',
    title: '落日列车',
    genre: '现实',
    status: '已完结',
    score: '9.6',
    chapter: '已完结',
    updateTime: '完结佳作',
    tags: ['成长', '公路'],
    desc: '最后一班穿过落日的列车，载着每个人未完的梦想远行。',
    image: 'https://readdy.ai/api/search-image?query=a%20train%20silhouette%20passing%20through%20golden%20sunset%20hills%20with%20long%20shadows%2C%20cinematic%20anime%20comic%20cover%20art%2C%20warm%20orange%20and%20purple%20sky%2C%20high%20detail&width=600&height=800&seq=comic-s4&orientation=portrait',
  },
];

export const popularSerials: Comic[] = [
  {
    id: 'p1',
    title: '长安十二食',
    genre: '古风',
    status: '连载中',
    score: '9.1',
    chapter: '第156话',
    updateTime: '热更中',
    tags: ['美食', '唐朝'],
    desc: '长安街头十二道名菜，见证盛唐市井里的烟火人间。',
    image: 'https://readdy.ai/api/search-image?query=ancient%20tang%20dynasty%20street%20food%20market%20with%20warm%20lanterns%20and%20food%20stalls%20at%20night%2C%20rich%20anime%20comic%20cover%20art%2C%20warm%20gold%20and%20red%20tones%2C%20high%20detail&width=600&height=800&seq=comic-p1&orientation=portrait',
  },
  {
    id: 'p2',
    title: '机甲少年团',
    genre: '热血',
    status: '连载中',
    score: '9.0',
    chapter: '第122话',
    updateTime: '热更中',
    tags: ['机甲', '团队'],
    desc: '五名热血少年共同驾驶巨型机甲，守护他们热爱的城市。',
    image: 'https://readdy.ai/api/search-image?query=a%20team%20of%20boys%20piloting%20a%20colorful%20giant%20mecha%20in%20an%20energetic%20pose%2C%20punchy%20anime%20comic%20cover%20art%2C%20bright%20vibrant%20colors%2C%20high%20detail&width=600&height=800&seq=comic-p2&orientation=portrait',
  },
  {
    id: 'p3',
    title: '妖怪公寓',
    genre: '日常',
    status: '连载中',
    score: '8.9',
    chapter: '第88话',
    updateTime: '热更中',
    tags: ['妖怪', '温馨'],
    desc: '住满可爱妖怪的老公寓，每天都有意想不到的温馨故事。',
    image: 'https://readdy.ai/api/search-image?query=quirky%20ghosts%20and%20yokai%20living%20in%20a%20cozy%20old%20apartment%20building%20with%20warm%20lights%2C%20charming%20anime%20comic%20cover%20art%2C%20soft%20warm%20tones%2C%20high%20detail&width=600&height=800&seq=comic-p3&orientation=portrait',
  },
  {
    id: 'p4',
    title: '都市修仙传',
    genre: '修仙',
    status: '连载中',
    score: '9.2',
    chapter: '第300话',
    updateTime: '热更中',
    tags: ['修仙', '都市'],
    desc: '隐于市井的年轻修士，在摩天楼之间寻一条通天之路。',
    image: 'https://readdy.ai/api/search-image?query=a%20young%20cultivator%20meditating%20floating%20above%20a%20modern%20city%20with%20glowing%20qi%20energy%2C%20mystical%20anime%20comic%20cover%20art%2C%20gold%20and%20teal%20glow%2C%20high%20detail&width=600&height=800&seq=comic-p4&orientation=portrait',
  },
];

export const heroImage =
  'https://readdy.ai/api/search-image?query=a%20colorful%20collage%20of%20anime%20manga%20books%20and%20heroic%20characters%20flying%20among%20dynamic%20illustration%20panels%2C%20vibrant%20cartoon%20style%2C%20warm%20coral%20orange%20and%20cream%20palette%2C%20energetic%20composition%2C%20artistic%20and%20abstract%2C%20high%20detail&width=1600&height=900&seq=comic-hero&orientation=landscape';

export const categories = [
  { name: '热血战斗', icon: 'ri-flashlight-fill', color: 'primary' },
  { name: '恋爱治愈', icon: 'ri-heart-3-fill', color: 'accent' },
  { name: '科幻机甲', icon: 'ri-rocket-2-fill', color: 'secondary' },
  { name: '悬疑推理', icon: 'ri-search-eye-fill', color: 'primary' },
  { name: '古风仙侠', icon: 'ri-meteor-fill', color: 'accent' },
  { name: '日常轻松', icon: 'ri-cup-fill', color: 'secondary' },
];

export const faqList = [
  {
    q: '卡通动漫第一页多久更新一次热门榜单？',
    a: '热门榜单每天定时刷新，综合当日的阅读热度、点赞与收藏数据自动排序，确保你每次打开都能看到最新的追更风向标。',
  },
  {
    q: '编辑推荐的漫画是从哪里挑选的？',
    a: '编辑团队会从新作首发、高分连载和优质完结作品中进行多轮筛选，重点关注剧情、画风与口碑，再结合读者反馈精选出真正值得一看的作品。',
  },
  {
    q: '今日更新板块会收录哪些作品？',
    a: '今日更新汇总了当下热门的连载作品最新话，按更新时间倒序排列，方便漫迷第一时间跟进自己追更的进度。',
  },
  {
    q: '高分漫画的评分标准是什么？',
    a: '高分漫画综合了读者评分、完读率与长期口碑，9.0 以上的作品通常代表稳定出色的剧情质量和持续高涨的人气。',
  },
  {
    q: '新作首发如何判断一部作品值不值得追？',
    a: '新作首发会优先展示开篇节奏紧凑、画风亮眼、设定有辨识度的作品，同时标注题材和标签，帮你快速找到对味的连载。',
  },
  {
    q: '为什么有些作品标为“已完结”？',
    a: '已完结代表整部作品已经更新完毕，可以一口气看完，适合喜欢一次性读完完整故事的读者。',
  },
];